import { render, staticRenderFns } from "./SearchPerformedAnalyticsDashboard.vue?vue&type=template&id=0e85d1b0&scoped=true&"
import script from "./SearchPerformedAnalyticsDashboard.vue?vue&type=script&lang=js&"
export * from "./SearchPerformedAnalyticsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./SearchPerformedAnalyticsDashboard.vue?vue&type=style&index=0&id=0e85d1b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e85d1b0",
  null
  
)

export default component.exports